import { Component, OnInit, Type, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';

/**
 * Interface for tab definition
 */
export interface TabDefinition {
  label: string;
  content: Type<any>;
}

/**
 * TabsBlockComponent - A reusable component for displaying tabs with lazy-loaded content
 *
 */
@Component({
  selector: 'app-tabs-block',
  imports: [CommonModule, MatTabsModule],
  templateUrl: './tabs-block.component.html',
  styleUrls: ['./tabs-block.component.scss'],
})
export class TabsBlockComponent implements OnInit {
  readonly tabs = input<TabDefinition[]>([]);
  readonly activeTabIndex = signal(0);
  readonly initialTabIndex = input<number>(0);
  readonly align = input<'start' | 'center' | 'end'>('center');
  /**
   * Whether tabs should stretch to fill available space
   */
  readonly stretch = input<boolean>(false);
  readonly tabChange = output<number>();

  /**
   * Initializes the component by setting the active tab index from the input
   */
  ngOnInit(): void {
    this.activeTabIndex.set(this.initialTabIndex());
  }

  /**
   * Handles tab change events and emits the new index
   * @param index The index of the newly selected tab
   */
  onTabChange(index: number): void {
    this.activeTabIndex.set(index);
    this.tabChange.emit(index);
  }
}
